import { DateTime } from '@ksyos/date-time';
import type {
    GetOutclinicDashboardProcessesResponseBody,
    GetOutclinicDashboardStepCountsResponseBody,
    GetOutclinicDashboardStepGroupsResponseBody,
    IGetOutclinicDashboardProcessesQuery,
    IGetOutclinicDashboardStepCountsQuery,
} from '@common/interfaces/api/outclinicDashboardApi';
import { fetchJson } from '@frontend/store/fetch';
import { getUrlQueryParameters } from './queryParameterUtils';

const baseUrl = '/api/outclinicDashboard';

export async function getStepCounts(
    serviceId: string,
    query: IGetOutclinicDashboardStepCountsQuery | undefined,
    signal: AbortSignal
): Promise<GetOutclinicDashboardStepCountsResponseBody> {
    const url = getUrlQueryParameters<IGetOutclinicDashboardStepCountsQuery>(
        `${baseUrl}/${serviceId}/stepCounts`,
        query
    );

    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json;
}

export async function getStepGroups(
    serviceId: string,
    signal: AbortSignal
): Promise<GetOutclinicDashboardStepGroupsResponseBody> {
    const url = `${baseUrl}/${serviceId}/stepGroups`;
    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json;
}

export async function listProcesses(
    serviceId: string,
    query: IGetOutclinicDashboardProcessesQuery,
    signal: AbortSignal
): Promise<GetOutclinicDashboardProcessesResponseBody> {
    const url = getUrlQueryParameters<IGetOutclinicDashboardProcessesQuery>(`${baseUrl}/${serviceId}/processes`, query);
    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json;
}

export async function snoozeProcess(
    {
        serviceId,
        processId,
        isSnoozed,
        snoozedUntilDateTime,
    }: {
        isSnoozed: boolean;
        processId: string;
        serviceId: string;
        snoozedUntilDateTime?: string;
    },
    signal: AbortSignal
): Promise<void> {
    const url = `${baseUrl}/${serviceId}/processes/${processId}/snooze`;

    const body = {
        isSnoozed,
        snoozedUntilDateTime: DateTime.from(snoozedUntilDateTime ?? new Date()).format('YYYY-MM-DD HH:mm:ss'),
    };

    await fetchJson({ body, method: 'POST', signal, url });
}
